import { atom } from 'recoil';

export const LoadingAtom = atom({
  key: 'LoadingAtom',
  default: false
});

export const CanvasResizeAtom = atom({
  key: 'CanvasResizeAtom',
  default: {
    width: window.innerWidth,
    heigth: window.innerHeight
  }
});

/**
 * CanvasTypeAtom - 캔버스 타입
 *
 * default: 기본
 * bundang: 분당
 * paju: 파주
 */
export const CanvasTypeAtom = atom({
  key: 'CanvasType',
  default: 'default'
});

/**
 * LocationNameEditModalAtom - 위치정보 이름 수정 모달
 */
export const LocationNameEditModalAtom = atom({
  key: 'LocationNameEditModalAtom',
  default: false
});

/**
 * LocationNameEditDataAtom - 위치정보 이름 수정 데이터
 */
export const LocationNameEditDataAtom = atom({
  key: 'LocationNameEditDataAtom',
  default: undefined
});

/**
 * BeaconEditModalAtom - 비콘 정보 수정 모달
 */
export const BeaconEditModalAtom = atom({
  key: 'BeaconEditModalAtom',
  default: false
});

/**
 * BeaconEditDataAtom - 비콘 정보 수정 데이터
 */
export const BeaconEditDataAtom = atom({
  key: 'BeaconEditDataAtom',
  default: undefined
});

/**
 * ViewerSiderActiveTabKeyAtom - 사이드 탭 활성화 키
 */
export const ViewerSiderActiveTabKeyAtom = atom({
  key: 'ViewerSiderActiveTabKeyAtom',
  default: 'site-information'
});

/**
 * HeaderActiveTabKeyAtom - 헤더 메뉴 활성화 키
 */
export const HeaderActiveTabKeyAtom = atom({
  key: 'HeaderActiveTabKeyAtom',
  default: 'viewer'
});

/**
 * HighlightAtom - 하이라이트
 */
export const HighlightAtom = atom({
  key: 'HighlightAtom',
  default: false
});

/**
 * CameraEditModeAtom - 카메라 편집 모드
 */
export const CameraEditModeAtom = atom({
  key: 'CameraEditModeAtom',
  default: false
});

/**
 * PhotoSaveConfirmModalAtom - 사진 저장 확인 모달
 */
export const PhotoSaveConfirmModalAtom = atom({
  key: 'PhotoSaveConfirmModalAtom',
  default: false
});

/**
 * PhotoSaveConfirmCallbackAtom - 사진 저장 확인 콜백
 */
export const PhotoSaveConfirmCallbackAtom = atom({
  key: 'PhotoSaveConfirmCallbackAtom',
  default: {
    onOk: null,
    onCancel: null
  }
});
